import { POS_ROUTE } from "../../constants/constants"

export const RESERVATIONS_LIST_ROUTE = POS_ROUTE + "/reservations"

